export { BvlFormRadioComponent as BvlFormRadio } from './form-radio.component';
export { BvlFormRadioModule } from './form-radio.module';